import {
  Draggable,
  DraggableCore
} from "./chunk-ACOTSM7X.mjs";

// lib/cjs.ts
var cjs_default = Draggable;
export {
  DraggableCore,
  cjs_default as default
};
//# sourceMappingURL=cjs.mjs.map